import { render, staticRenderFns } from "./BuyNowProductChip.vue?vue&type=template&id=c088bba6&scoped=true"
import script from "./BuyNowProductChip.vue?vue&type=script&lang=js"
export * from "./BuyNowProductChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c088bba6",
  null
  
)

export default component.exports